interface Action {
    payload: any,
    type: string
}

const ErrorReducer = (state = {}, action: Action) => {
    switch (action.type) {
        case 'GET_USER_ERROR':
            return {
                User:action.payload
            };
        case "RESET_USER_ERROR":
            return {};
        default:
            return state;
    }
};

export default ErrorReducer;
